import type {Regal} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';

export default class ExemplarPlacementDataService {
    public static readonly serviceName = 'exemplarPlacementDataService';

    private static readonly EXEMPLAR_PLACEMENT_ROUTE = 'exemplar-placements';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public getExemplarPlacement(exemplarId: number): PromiseLike<Regal> {
        return this.Restangular
            .one(ExemplarPlacementDataService.EXEMPLAR_PLACEMENT_ROUTE)
            .get({exemplar: exemplarId});
    }
}
